/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */
import { Fragment, useEffect, useState } from 'react';
import { useGlobals, useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CloudinaryPicture, ModalBleed, Icon } from '@bwoty-web/ui-kit';
import { UI_LOGO } from '@bwoty-web/ui-kit/icons'
import './roomGallery.scss';

const imageSizes = [
  {
    width: 1224,
    breakpoint: 1024,
  },
  {
    width: 1024,
    breakpoint: 768,
  },
  {
    width: 768,
    breakpoint: 415,
  },
];

const imageSizesPopUp = [
  {
    width: 1024,
    breakpoint: 768,
  },
  {
    width: 768,
    breakpoint: 415,
  },
];

const RoomGallery = ({ gallery, hasNoImage, labels, inPopup, roomImageMissing }) => {

  const { hotelHasParts } = useGlobals();
  const isGlobetrotter = useIsGlobetrotter();

  const [selectedImage, setSelectedImage] = useState(0);
  useEffect(() => {
    if (selectedImage !== 0)
      document
        .querySelector('.gw-room-gallery__thumbnail-tab[aria-selected]')
        .focus();
  }, [selectedImage]);


  const LargeImageWrapper = inPopup ? ModalBleed : Fragment;
  const roomImage = hasNoImage ? roomImageMissing?.media?.cloudinaryUriTemplate : gallery[selectedImage]?.cloudinaryUriTemplate;

  return (
    <div className="gw-room-gallery">
      <LargeImageWrapper>
        <div
          className="gw-room-gallery__image-wrapper"
          id="gw-room-gallery-image"
        >
          {!roomImage && isGlobetrotter ? (
            <div className="gw-room-gallery__default-image">
              <Icon path={UI_LOGO} size="xl" />
            </div>
          ) : (gallery[selectedImage] || hasNoImage) && (
            <>
              <CloudinaryPicture
                className={cx("gw-room-gallery__image", {
                  "gw-room-gallery__image--map": hotelHasParts && selectedImage === gallery.length - 1,
                })}
                img={{
                  cloudinaryUriTemplate:
                    roomImage,
                }}
                sizes={inPopup ? imageSizesPopUp : imageSizes}
                retina
              />
              {gallery[selectedImage]?.text && !hasNoImage && (
                <div className="gw-room-gallery__image-text-wrapper">
                  <span className="gw-room-gallery__image-text">
                    {gallery[selectedImage]?.text}
                  </span>
                </div>
              )}
            </>
          )}
          {hasNoImage && !isGlobetrotter && (
            <div className="gw-room-gallery__default-image-overlay">
              <span>{labels?.roomImageMissing}</span>
            </div>
          )}
        </div>
      </LargeImageWrapper>
      {gallery?.length > 1 && (
        <div
          className="gw-room-gallery__thumbnails"
          aria-controls="gw-room-gallery-image"
        >
          {gallery?.map((picture, i) => (
            <button
              type="button"
              onClick={() => setSelectedImage(i)}
              key={uniqid('room-gallery-thumbnail')}
              className="gw-room-gallery__thumbnail-tab"
              {...(i === selectedImage && {
                'aria-selected': true,
              })}
            >
              <div
                className={cx('gw-room-gallery__thumbnails-image', {
                  'gw-room-gallery__thumbnails-image--selected':
                    i === selectedImage,
                })}
              >
                <CloudinaryPicture
                  img={{
                    cloudinaryUriTemplate: picture?.cloudinaryUriTemplate,
                  }}
                  sizes={[{ width: 89, height: 58 }]}
                  data-gtm-tag="Accom Room type image"
                  lazy
                  retina
                />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

RoomGallery.propTypes = {
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      sources: PropTypes.arrayOf(
        PropTypes.shape({
          srcSet: PropTypes.string,
          type: PropTypes.string,
          media: PropTypes.string,
        }),
      ),
      cloudinaryUriTemplate: PropTypes.string,
      size: PropTypes.PropTypes.shape({}),
      text: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ).isRequired,
  labels: PropTypes.shape({
    roomImageMissing: PropTypes.string,
  }),
  hasNoImage: PropTypes.bool,
  inPopup: PropTypes.bool,
  roomImageMissing: PropTypes.shape({
    media: PropTypes.shape({
      cloudinaryUriTemplate: PropTypes.string,
    }),
  }),
};

RoomGallery.defaultProps = {
  hasNoImage: false,
  labels: {},
  inPopup: false,
  roomImageMissing: {},
};

export default RoomGallery;
